export default __webpack_public_path__ + "static/image13-9e680ec3efe38c20f32ef98c1f274a47.jpeg";